import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CustomLink from './CustomLink';
import { handleScrollOnId } from '../../hooks/handleScrollOnId';
import { GiHamburgerMenu, GiCancel } from 'react-icons/gi';
import '../../../src/index.css';
import styles from './NavigationBar.module.css';
import { setMode } from '../../state';
import { IconButton, useTheme } from '@mui/material';
import { DarkModeOutlined, LightModeOutlined } from '@mui/icons-material';

const NavigationBar = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const [menuStyle, setMenuStyle] = useState(true);
  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.scrollY;
    // console.log(position);
    setScrollPosition(position);
    setMenuStyle(true);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const leftBarHandler = () => {
    setMenuStyle(!menuStyle);
    // if (!menuStyle) {
    // Prevent scrolling when isScrollDisabled is true
    // window.scrollTo(0, 0);
    // }
  };
  return (
    <>
      <nav className={scrollPosition > 20 ? `${styles.navbar} ${styles.sticky}` : styles.navbar}>
        <div className={styles.content}>
          <div className={styles.flex}>
            <h1 className={`${styles.logo} ${styles.unselectable}`}>SmartPush</h1>
            <h5 className={`${styles.quote} ${styles.unselectable}`}>cesta k přírodě...</h5>
          </div>
          <ul className={menuStyle ? styles.menuList : `${styles.menuList} ${styles.active}`}>
            <div className={`${styles.icon} ${styles.cancelBtn}`}>
              <i onClick={leftBarHandler} className={`${styles.fas} ${styles.faTimes}`}>
                <GiCancel />
              </i>
            </div>
            <CustomLink
              to="/"
              onClick={() => handleScrollOnId('homeSection')}
              className={styles.nav}
            >
              Domů
            </CustomLink>

            <CustomLink className={styles.nav} to="/blog">
              Blog
            </CustomLink>

            {/* <li>
              <CustomLink className={styles.nav} to="/pricing">
                Ceník
              </CustomLink>
             */}
            <CustomLink
              to="/"
              onClick={() => handleScrollOnId('serviceSection')}
              className={styles.nav}
            >
              Služby
            </CustomLink>

            <CustomLink
              to="/"
              onClick={() => handleScrollOnId('contactSection')}
              className={styles.nav}
            >
              Kontakt
            </CustomLink>
          </ul>

          <IconButton onClick={() => dispatch(setMode())}>
            {theme.palette.mode === 'dark' ? (
              <DarkModeOutlined sx={{ fontSize: '25px' }} />
            ) : (
              <LightModeOutlined sx={{ fontSize: '25px' }} />
            )}
          </IconButton>
          <div
            onClick={leftBarHandler}
            className={
              menuStyle
                ? `${styles.icon} ${styles.menuBtn}`
                : ` ${styles.hide} ${styles.icon} ${styles.menuBtn}`
            }
          >
            <i className={`${styles.fas} ${styles.faBars}`}>
              <GiHamburgerMenu />
            </i>
          </div>
        </div>
      </nav>
      {/* <img src={backgroundPhoto} alt="Hydroponie background" className={styles.banner} id="homeSection"></img> */}
    </>
  );
};

export default NavigationBar;
